import React from "react";
import PropTypes from "prop-types";

import {PRICING_FEATURE_PROPERTIES, PRICING_FEATURE_PROPERTIES_ARRAY} from "./pricingFeatureProperties";
import PricingCheckbox from "../PricingComponents/PricingCheckbox";


const PricingFeaturesListTableHeader = (props) => {

  const {columns, className, styles, selectAllClick, selectAllChecked} = props;

  return (
    <div className={"grid pr-grid " + (className || "")} style={styles}>
      <div className="pr-grid-th font--12">
        {PRICING_FEATURE_PROPERTIES_ARRAY.map(property => {
          if (!columns.includes(property)) {
            return null
          }
          if (property === "index") {
            return <div className="pr-grid-cell" key={property}/>
          }
          if (property === "checkbox") {
            return (
              <div className="pr-grid-cell flex flex--center" key={property}>
                <PricingCheckbox id={"select-features-all"}
                                 text={""}
                                 className="pr-checkbox--white min-h-125 flex flex--center"
                                 checked={selectAllChecked}
                                 onChange={selectAllClick}/>
              </div>
            )
          }
          return (
            <div className={"pr-grid-cell flex flex--center pl-05 pr-05" + (selectAllClick ? " color-black3" : "")}
                 key={property}>
              {PRICING_FEATURE_PROPERTIES[property].translate}
            </div>
          )
        })}
      </div>
    </div>
  )
};

PricingFeaturesListTableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  styles: PropTypes.object.isRequired,
  className: PropTypes.string,
  selectAllClick: PropTypes.func,
  selectAllChecked: PropTypes.bool,
}

export default PricingFeaturesListTableHeader
